module.exports = __webpack_public_path__ + "static/1 (8)-7c88137c20982dd1806e6feac67df27c.png";